// Aesthetic Labs – Clean Text Motion
(function () {

  const initMotion = () => {
    const texts = document.querySelectorAll(
      'h1, h2, h3, p, .subtitle, .caption, .button'
    );

    if (!('IntersectionObserver' in window)) {
      texts.forEach(el => el.classList.add('is-visible'));
      return;
    }

    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -6% 0px'
    });

    texts.forEach(el => {
      el.classList.add('al-text-reveal');
      io.observe(el);
    });
  };

  document.addEventListener('DOMContentLoaded', initMotion);
  document.addEventListener('shopify:section:load', initMotion);

})();
(function () {
  const overlay = document.getElementById('alOverlay');
  const content = document.getElementById('alOverlayContent');

  const data = {
    values: `
      <h1>Our Values</h1>
      <p>Disciplina. Constancia. Energía.</p>
    `,
    why: `
      <h1>Why We Do This</h1>
      <p>Nos enseñó disciplina cuando no había motivación...</p>
    `,
    about: `
      <h1>About Us</h1>
      <p>No buscamos definir el fitness. Lo vivimos y lo compartimos.</p>
    `
  };

  document.querySelectorAll('[data-overlay]').forEach(btn => {
    btn.addEventListener('click', () => {
      const key = btn.dataset.overlay;
      content.innerHTML = data[key] || '';
      overlay.classList.add('active');
    });
  });

  overlay.querySelector('.al-overlay__backdrop')
    .addEventListener('click', () => {
      overlay.classList.remove('active');
    });
})();
// ===============================
// Aesthetic Brand Gateway - Mobile Accordion
// ===============================
document.querySelectorAll('.al-col h4').forEach(title => {
  title.addEventListener('click', () => {
    const col = title.parentElement;
    col.classList.toggle('active');
  });
});
